import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";

const Logout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AuthService.logout();
    window.location = "/auth/login";
    //   navigate("/auth/login");
  }, []);
};

export default Logout;
